<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="top_rect">
      <div class="name_style">{{className}}</div>
    </div>
    <!--轮训班审核情况表-->
    <el-table
      :row-style="{ color: '#51627D', fontWeight: 400, textAlign: 'center' }"
      :header-cell-style="{ background: '#DCE7FA', color: '#343C4A', fontWeight: 500, textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      :data="situationList"
      border
      style="width: 100%">
      <template>
        <el-table-column
          label="报名期次"
          width="120">人数
        </el-table-column>
        <el-table-column
          label="审核通过"
          min-width="100%"
          >
          <template v-if="situationList.length > 0" >
            <el-table-column v-for="(value, key) in situationList[0].auditPassMap" :key="key" :label="key">
              <span>{{ value }}</span>
            </el-table-column>
            <el-table-column prop="auditPassAndNotJoinNum" label="不参加"></el-table-column>
          </template>
        </el-table-column>
        <el-table-column
          prop="auditingNum"
          label="审核中" 
          >
          <template v-if="situationList.length > 0" >
            <el-table-column v-for="(value, key) in situationList[0].auditMap" :key="key" :label="key" >
              <span>{{ value }}</span>
            </el-table-column>
            <el-table-column prop="auditAndNotJoinNum" label="不参加"></el-table-column>
          </template>
        </el-table-column>
        <el-table-column
          prop="auditFailNum"
          label="审核不通过"
          width="130">
        </el-table-column>
        
        <el-table-column
          prop="noSignUpNum"
          label="未报名"
          width="130">
        </el-table-column>
        <el-table-column
          prop="totalNum"
          label="合计人数"
          width="140">
        </el-table-column>
      </template>
    </el-table>

    <!--轮训班审核学员名单表-->
    <div class="top_rect m-t-24">
      <div class="title_style">
        <butn
          btntype="primary" 
          title="批量审核"
          :disabled="selections.length === 0"
          @click="batchOperation"
          v-permission="'audit:enroll:updateBatch'"
        ></butn>
        <butn
          btntype="primary" 
          title="导出"
          @click="exportClassAudit"
        ></butn>
      </div>
      <el-form class="right">
        <el-form-item class="select_btn">
          <el-select
            size="small"
            class="select_btn_style"
            v-model="filters.auditStatus"
            placeholder="审核状态"
          >
            <el-option
              v-for="(item, i) in auditStatusData"
              :key="i"
              :label="item.paramValue"
              :value="item.paramKey"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="m-l-14 m-r-12">
          <el-input
            prefix-icon="el-icon-search"
            size="small"
            v-model.trim="filters.auditDeptName"
            placeholder="工作单位"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <butn btntype="primary" title="查询" @click="searchHandle"></butn>
          <butn title="重置" @click="resetData" class="czButn"></butn>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      :row-style="{ color: '#51627D', fontWeight: 400 }"
      :header-cell-style="{ background: '#DCE7FA', color: '#343C4A', fontWeight: 500 }"
      :data="enrollList"
      @selection-change="selectionChange"
      border
      style="width: 100%">
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column
        prop="auditDeptName"
        label="工作单位"
        min-width="150%">
      </el-table-column>
      <el-table-column align="center" v-for="item in periodList" :key="item.periodId" :label="item.periodName">
        <!-- 匹配当前期次数据 -->
        <template slot-scope="scope">
          <span v-if="item.periodId !== '3'">{{ scope.row.enrollNumMap[`${item.periodName}`] || 0 }}</span>
          <span v-else>{{ scope.row.noJoinNum || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="auditUserName"
        label="提交人"
        width="180">
      </el-table-column>
      <el-table-column
        prop="auditStatusName"
        label="审核状态"
        width="120">
      </el-table-column>
      <el-table-column
        prop="auditDate"
        label="报名时间"
        width="200">
      </el-table-column>
      <el-table-column
        prop="auditDate"
        label="操作"
        width="100">
        <template slot-scope="scope">
          <el-tooltip
            effect="dark"
            content="审核"
            placement="top"
            v-permission="'audit:enroll:updateBatch'"
            v-if="scope.row.auditStatus === 0"
          >
            <i
              :class="'icon-audit'"
              @click="gotoAudit(scope.row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            effect="dark"
            content="审核详情"
            placement="top"
            v-permission="'rotationAudit:enroll:page'"
          >
            <i
              :class="'icon-steps'"
              @click="showAuditDetail(scope.row)"
            ></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="RCPagination">
      <div style="float: left">
        <butn
          btntype="primary"
          iconName="el-icon-arrow-left"
          title="返回"
          @click="dealBack"
        ></butn>
      </div>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="sizeChange"
        :current-page.sync="filters.page"
        layout="total, sizes, prev, pager, next"
        :page-size="filters.limit"
        :page-sizes="[10, 50, 100, 500, 1000]"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 审核详情-->
    <AuditModal
      :showDialog="showDialog"
      :thisItem="selections"
      :className="className"
      v-if="showDialog.flag"
      @closeDialog="closeBatchDialog"
    />
  </div>
</template>
<script>
import butn from "@/components/button/index";
import {
  getPeriodList,
  getEnrollAuditSituation,
  getRotationClassAuditPage,
  exportRotationClassAudit
} from "@/api/enrollment";
import { getSysParamByTypes } from "@/api/sysParam";
import { getItem, removeItem } from "@/utils/storage.js";
import AuditModal from "../rotateUsers/auditModal.vue"
import { setItem } from "@/utils/storage.js";

export default {
  name: "enrollauditRotateUsers",
  components: {
    butn,
    AuditModal
  },
  activated() {
    if (getItem(this.REFRESH_FLAG)) {
      this.searchHandle();
      removeItem(this.REFRESH_FLAG);
    }
  },
  data: function() {
    return {
      selections: [],
      filters: {
        page: 1,
        limit: 10,
        auditDeptName: "",
        auditStatus: null,
      },
      total: 0,
      classId: "",
      className: "",
      periodList: [],
      situationList: [],
      enrollList: [],
      auditStatusData: [],
      showDialog: {
        flag: false
      }
    };
  },
  created() {
    //加载列表
    this.classId = this.$route.query.id;
    this.className = this.$route.query.className;
    this.getPeriodList();
    this.getEnrollAuditSituation();
    this.getRotationClassAuditPage();
    this.getSysParamByTypes([ "AUDIT_STATUS_BASIC" ]);
  },
  methods: {
    // 查询轮训班期次
    getPeriodList() {
      getPeriodList(this.classId).then(({ code, data }) => {
        if (code !== 0) return;
        this.periodList = data;
      });
    },
    // 查询轮训班报名审核情况
    getEnrollAuditSituation() {
      getEnrollAuditSituation(this.classId).then(({ code, data = {} }) => {
        if (code === 0) {
          this.situationList = [data];
        }
      });
    },
    // 轮训班报名审核申请分页列表
    getRotationClassAuditPage() {
      getRotationClassAuditPage({ bizId: this.classId, ...this.filters }).then(({ code, data }) => {
        if (code === 0) {
          this.enrollList = data.records || [];
          this.total = data.total;
        }
      });
    },
    // 分页
    handleCurrentChange(p) {
      this.filters.page = p;
      this.getRotationClassAuditPage();
    },
    sizeChange(size) {
      this.filters.limit = size;
      this.filters.page = 1;
      this.getRotationClassAuditPage();
    },
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["AUDIT_STATUS_BASIC"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.auditStatusData = res.data["AUDIT_STATUS_BASIC"];
      });
    },
    // 跳转审核详情
    gotoAudit(item) {
      this.$router.push({ path: "/enrollaudit/auditDetail", query: { classId: this.classId, deptId: item.auditDeptId, auditApplyId: item.auditApplyId, auditStatus: item.auditStatus, className: this.className }});
    },
    // 审核详情
    showAuditDetail(item) {
      this.$router.push({ path: "/enrollaudit/auditDetail", query: { classId: this.classId, deptId: item.auditDeptId, auditApplyId: item.auditApplyId }});
    },
    // 批量审核
    batchOperation() {
      this.showDialog.flag = true;
      // vue.$emit("ShowAuditModal", this.selections, this.className, 1);
    },
    // 关闭批量审核
    closeBatchDialog(flag) {
      this.showDialog.flag = false;
      if (flag) {
        this.getEnrollAuditSituation();
        this.searchHandle();
      }
    },

    //搜索学员
    searchHandle() {
      this.getRotationClassAuditPage();
    },
    resetData() {
      this.filters.auditStatus = null;
      this.filters.auditDeptName = "";
      this.getRotationClassAuditPage();
    },
    selectionChange: function(selections) {
      this.selections = selections;
    },
    dealBack() {
      setItem(this.REFRESH_FLAG, true);
      this.$router.push('/enrollaudit');
    },

    // 导出：轮训班报名审核情况
    exportClassAudit() {
      let params = {
        classId: this.classId
      };
      exportRotationClassAudit(params).then(response => {
        let data = response.data;
        let fileReader = new FileReader();
        let _this = this;
        fileReader.onload = function() {
          try {
            let jsonData = JSON.parse(this.result);
            if (jsonData.code) {
              _this.$message({
                message: jsonData.msg,
                type: "error"
              });
            }
          } catch (e) {
            let blob = new Blob([response.data], {
              type: "application/vnd.ms-excel"
            }); //创建一个blob对象
            const uA = window.navigator.userAgent;
            const isIE =
              /msie\s|trident\/|edge\//i.test(uA) &&
              !!(
                "uniqueID" in document ||
                "documentMode" in document ||
                "ActiveXObject" in window ||
                "MSInputMethodContext" in window
              );
            let a = document.createElement("a"); //创建一个<a></a>标签
            let href = window.URL.createObjectURL(blob); // response is a blob
            a.href = href;
            let title = decodeURI(escape(response.headers.downloadname)); //文件名称
            a.download = title;
            a.style.display = "none";
            document.body.appendChild(a);
            if (isIE) {
              // 兼容IE11无法触发下载的问题
              navigator.msSaveBlob(blob, title);
            } else {
              a.click();
            }
            document.body.removeChild(a); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放url
          }
        };
        fileReader.readAsText(data);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  /deep/.right .el-form-item {
    margin-bottom: 0;
  }
  .RCPagination {
    margin-bottom: 16px;
  }
  .m-r-12 {
    margin-right: 12px;
  }
  .m-t-24 {
    margin-top: 32px;
  }
  .enrollStatus_style {
    color:#3A85FF;
    cursor: pointer;
  }
  .top_rect {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    margin-top: 12px;
    .name_style {
      font-size: 20px;
      font-weight: bold;
      color: #000;
      padding: 10px 0;
    }
    .title_style {
      font-size: 18px;
      font-weight: bold;
    }
    .tip_style {
      font-size: 12px;
    }
    .right {
      display: flex;
      align-items: center;
    }
  }
</style>
